// Обертка над Vue.

// Если использовать нормальный импорт, то vue попадет в сборку дважды
// (один раз в common, второй в скрипт страницы).
// Поэтому вместо импорта используем глобальный объект.
// import Vue from "vue";

const { Vue } = window;

const createComponent = (config, selector) => {
    if (!document.querySelector(selector)) return;
    const app = Vue.createApp(config);
    app.config.errorHandler = (err, vm, info) => {
        console.error(err, vm, info);
    };
    app.config.warnHandler = (err, vm, trace) => {
        console.warn(err, vm, trace);
    };
    app.config.compilerOptions.delimiters = ["[[", "]]"];
    app.directive("click-outside", {
        mounted(el, binding) {
            const curTime = new Date()
                .getTime();
            const handler = e => {
            // Ignore early events
                if (new Date()
                    .getTime() - curTime < 10) return;

                if (!el.contains(e.target) && el !== e.target) {
                    binding.value(e);
                }
            };
            el.__vueClickOutside__ = handler;

            // add Event Listeners
            document.addEventListener("mousedown", handler);
        },

        unmounted(el) {
        // Remove Event Listeners
            document.removeEventListener("mousedown", el.__vueClickOutside__);
            el.__vueClickOutside__ = null;
        },
    });
    app.mount(selector);
};

export default createComponent;
